var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  stroke: "currentColor",
  width: 43,
  height: 15,
  viewBox: "0 0 43 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l20.5 12L42 1",
  strokeWidth: 2,
  fill: "none"
})));
export default SvgArrowDown;